import React, { useRef, useState } from 'react';
import BaseContainer from "../BaseContainer";
import H1 from '../Headings/H1';
import CompareTable from './CompareTable';
import MobileCompareTable from './MobileCompareTable';
import { pureKeys } from '../../utils/helpers';
import Layout from '../Layout';
import styles from '../Tabs/tabs.module.scss';

const OurExpertiseComp = ({ data })=> {
  const { title, heading, description, backgroundWhite=false, ourExpertiseTab, IsActiveComparison, IsActiveProductCategorySlider, IsActiveProductsTab } = data;
  const [tabActive,  setTabActive] = useState(0);
  const scrollTabRef = useRef()

  const productCategory = ourExpertiseTab[0].productCategory;  
  const displayActiveComparison = IsActiveComparison.toLowerCase() === "true" ? true : false;
  const displayActiveProductCategorySlider = IsActiveProductCategorySlider.toLowerCase() === "true" ? true : false;
  const displayIsActiveProductsTab = IsActiveProductsTab.toLowerCase() === "true" ? true : false;
  const cardClass = displayActiveProductCategorySlider ? 'h-[90px]': 'h-[196px] lg:h-[90px]';
  
  if(!productCategory.length){
    return true;
  }


  const handleTabs = (e, index) => {
    setTabActive(index)
    
    const container = scrollTabRef.current
    if (container) {
      const scrollAmount = e.currentTarget.offsetLeft - (container.scrollLeft + 20);
      container.scrollTo({ left: scrollAmount, behavior: 'smooth' });
    }
  }

  const renderTabList = () => {
    if(ourExpertiseTab && ourExpertiseTab.length){
      return (
        <div className="flex justify-center my-4 lg:my-6">
          <ul ref={scrollTabRef} className={`flex gap-6 -mx-4 lg:mx-0 px-4 list-none overflow-auto whitespace-nowrap hide-scroll-appearance ${styles.tabs}}`}>
            {ourExpertiseTab.map((tab, index) => {
              return (
                <li onClick={(e) => handleTabs(e, index)} className={`text-base lg:text-lg relative tracking-[0.31px] lg:tracking-[0.36px] pb-2.5 border-b-2 ${tabActive === index ? "font-bold border-ek-red cursor-default" : "border-black/[0] cursor-pointer"} ${!displayActiveComparison && index === 1 ? "hidden" : "" }`} key={pureKeys(tab.title)}>
                  {tab?.title}
                </li>
              )
            })}
          </ul>
        </div>
      )
    }
  }
  
  const renderHead=()=>{
    return (
      <div className="lg:max-w-[668px] m-auto">
        {title && title !== "" && <div className="mb-4 text-xs font-bold text-ek-red tracking-[4.8px] text-center">{title}</div>}
        {heading && heading !== "" && <H1 className="text-center mb-4">{heading}</H1>}
        {description && description !== "" && <div className="text-ek-grey-500 text-center tracking-[0.64px] mb-4" dangerouslySetInnerHTML={{ __html: description }}></div>}
      </div>
    )
  }

  const renderContent=()=>{
    if(displayActiveProductCategorySlider){
      return (<Layout type='SLIDER' Cards={productCategory} className={cardClass} />);
    }
    else{
      return(
        <>
        {tabActive === 0 && <Layout type='ALL' Cards={productCategory} className={cardClass} />}
        {tabActive === 1 && displayActiveComparison && <><div className="hidden lg:block"><CompareTable data={data} /></div><div className="lg:hidden"><MobileCompareTable data={data} /></div></>}
      </>
      )
    }
  }
 
  return (
      <div className={`${backgroundWhite?'bg-white py-[40px] lg:py-[80px]':'bg-transparent mt-[40px] lg:mt-[80px] mb-[40px] lg:mb-[80px]'}`}>
        <BaseContainer>
            {renderHead()}
            {displayIsActiveProductsTab && renderTabList()}
            {renderContent()}
        </BaseContainer>
      </div>

  )
}

export default OurExpertiseComp;